import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProgramService } from '../../../services/vpp/program.service';
import { ProgramViewComponent } from './program-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DatepickerComponent} from '../../shared/datepicker/datepicker.component';
import {NgbActiveModal, NgbDatepickerModule, NgbModule, NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ProgramEditComponent} from './program-edit/program-edit.component';
import {ProgramSitesComponent} from './program-sites/program-sites.component';
import {ProgramSiteModalComponent} from './program-site-modal/program-site-modal.component';
import {CalibrantLoadModule} from '../../shared/calibrant-load/calibrant-load.module';
import {DispatchModule} from '../dispatch/dispatch.module';
import {ProgramDetailsModule} from '../program-details/program-details.module';
import {MapModule} from '../../shared/map/map.module';
import {SlideToggleModule} from '../../shared/slide-toggle/slide-toggle.module';
import {MatTabsModule} from "@angular/material/tabs";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatDividerModule} from "@angular/material/divider";
import {NgSelectModule} from "@ng-select/ng-select";
import { MatOptgroup, MatOption, MatRipple } from '@angular/material/core';
import { MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatChip, MatChipGrid, MatChipInput, MatChipRemove, MatChipRow } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    FontAwesomeModule,
    CalibrantLoadModule,
    DispatchModule,
    ProgramDetailsModule,
    MapModule,
    SlideToggleModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    NgSelectModule,
    MatRipple,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatLabel,
    MatSelect,
    MatOptgroup,
    MatCheckbox,
    MatOption,
    MatFormField,
    MatProgressSpinner,
    MatChip,
    MatAutocompleteTrigger,
    MatChipInput,
    MatAutocomplete,
    MatChipGrid,
    MatChipRow,
    MatChipRemove,
  ],
    declarations: [
        ProgramViewComponent,
        ProgramEditComponent,
        ProgramSitesComponent,
        ProgramSiteModalComponent,
        DatepickerComponent,
    ],
    exports: [
        ProgramViewComponent,
    ],
    providers: [
        ProgramService,
        NgbActiveModal
    ]
})
export class ProgramViewModule { }
